import { FAQS } from '../../../core/constants/faq';
import { PAGE_META, SITE_NAME, SITE_SLOGAN } from '../../../core/constants/seo';
import { SERVICES } from '../../../core/constants/services';
import { useHashScroll } from '../../../core/hooks/useHashScroll';
import { usePageMeta } from '../../../core/hooks/usePageMeta';
import { site } from '../../../global/config/site';
import StructuredData from '../../../common/components/StructuredData/StructuredData';
import { buildLandingStructuredData } from '../utils/structured-data';
import About from './about';
import Audiences from './audiences';
import Contact from './contact';
import Cta from './cta';
import Faq from './faq';
import Hero from './hero';
import Process from './process';
import Services from './services';
import Solutions from './solutions';

const PAGE = { ...PAGE_META.HOME, url: `${site.url}${PAGE_META.HOME.path}` };

const STRUCTURED_DATA = buildLandingStructuredData({
    siteUrl: site.url,
    email: site.contactEmail,
    name: SITE_NAME,
    slogan: SITE_SLOGAN,
    logoPath: '/logo.png',
    services: SERVICES,
    faqs: FAQS,
});

export default function LandingOverview() {
    useHashScroll();
    usePageMeta(PAGE);

    return (
        <>
            <StructuredData data={STRUCTURED_DATA} />
            <Hero />
            <Audiences />
            <Services />
            <Process />
            <Solutions />
            <About />
            <Cta />
            <Faq />
            <Contact />
        </>
    );
}
